import Head from 'next/head'
import React from 'react'

const SnapchatPixel = () => {
    return (
        <Head>
            <script
                dangerouslySetInnerHTML={{
                    __html: `
                        (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
                        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
                        a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
                        r.src=n;var u=t.getElementsByTagName(s)[0];
                        u.parentNode.insertBefore(r,u);})(window,document,
                        'https://sc-static.net/scevent.min.js');
                        snaptr('init', '8e426a81-b23f-42d9-b34b-79e89df19cc5');
                        snaptr('track', 'PAGE_VIEW');
                    `,
                }}
            />
        </Head>
    )
}

export default SnapchatPixel
